import {
  CREATE,
  DELETE,
  DELETE_MANY,
  GET_LIST,
  GET_MANY,
  GET_MANY_REFERENCE,
  GET_ONE,
  UPDATE,
  UPDATE_MANY,
} from 'react-admin';
import ApolloClient from 'apollo-boost';

import * as gqlTypes from 'graphql-ast-types-browser';
import buildDataProvider from './hasura-graphql-samagra';
import { buildQueryFactory } from './hasura-graphql-samagra/buildQuery';
import buildVariables from './hasura-graphql-samagra/buildVariables';
import {
  buildGqlQuery,
  buildFields,
  buildMetaArgs,
  buildArgs,
  buildApolloArgs,
} from './hasura-graphql-samagra/buildGqlQuery';
import getResponseParser from './hasura-graphql-samagra/getResponseParser';

// dependency injection
const headers = {
  'content-type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
};

export const buildFieldsCustom = (type) => {
  const res = buildFields(type);
  if (type.name === 'teacher_attendance_updated') {
    // here we add additional fields we want to query for apps.
    // we are using the graphql-ast-types functions which is ast representation for graphql
    res.push(
      gqlTypes.field(
        gqlTypes.name('school'),
        null,
        null,
        null,
        gqlTypes.selectionSet([
          gqlTypes.field(gqlTypes.name('district')),
          gqlTypes.field(gqlTypes.name('block')),
          gqlTypes.field(gqlTypes.name('school_name')),
        ])
      )
    );
  } else if (type.name === 'attendance') {
    res.push(
      gqlTypes.field(
        gqlTypes.name('studentByStudent'),
        null,
        null,
        null,
        gqlTypes.selectionSet([
          gqlTypes.field(gqlTypes.name('name')),
          gqlTypes.field(gqlTypes.name('grade')),
          gqlTypes.field(gqlTypes.name('section')),
          gqlTypes.field(
            gqlTypes.name('school'),
            null,
            null,
            null,
            gqlTypes.selectionSet([
              gqlTypes.field(gqlTypes.name('district')),
              gqlTypes.field(gqlTypes.name('block')),
              gqlTypes.field(gqlTypes.name('school_name')),
            ])
          ),
        ])
      )
    );
  } else if (type.name === 'school') {
    res.push(
      gqlTypes.field(
        gqlTypes.name('school_mentor_mapping'),
        null,
        null,
        null,
        gqlTypes.selectionSet([
          gqlTypes.field(gqlTypes.name('mentor_username')),
          gqlTypes.field(gqlTypes.name('mentor_block')),
          gqlTypes.field(gqlTypes.name('mentor_mobile'))
        ])
      )
    );
  }
  return res;
};
const buildGqlQueryCustom = (iR) =>
  buildGqlQuery(
    iR,
    buildFieldsCustom,
    buildMetaArgs,
    buildArgs,
    buildApolloArgs
  );
const buildQuery = buildQueryFactory(
  buildVariables,
  buildGqlQueryCustom,
  getResponseParser
);

const client = new ApolloClient({
  uri: process.env.REACT_APP_HASURA_SERVER_URL,
  headers
});

export default buildDataProvider({
  client,
  buildQuery,
}).then((dataProviderHasura) => ({
  getList: (resource, params) => dataProviderHasura.getList(resource, params),
  getOne: (resource, params) => dataProviderHasura.getOne(resource, params),
  getMany: (resource, params) => dataProviderHasura.getMany(resource, params),
  getManyReference: (resource, params) =>
    dataProviderHasura.getManyReference(resource, params),
  update: (resource, params) => dataProviderHasura.update(resource, params),
  updateMany: (resource, params) =>
    dataProviderHasura.updateMany(resource, params),
  create: (resource, params) => dataProviderHasura.create(resource, params),
  delete: (resource, params) => dataProviderHasura.delete(resource, params),
  deleteMany: (resource, params) =>
    dataProviderHasura.deleteMany(resource, params),
}));
